import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { AutoCategorySlide } from '@autos/auto-results/entities/auto-category-slide';
import {
  AutoFiltersPayloadState
} from '@autos/auto-results/store/reducers/auto-filters-payload.reducer';
import { VehicleOption } from '@autos/entities/vehicle';
import { VehicleFilterPayload } from '@autos/entities/vehicle-filter.payload';
import { VehicleFilterResponse } from '@autos/entities/vehicle-filter.response';
import { VehicleResultsPayload } from '@autos/entities/vehicle-results.payload';
import { VehicleSearchPayload } from '@autos/entities/vehicle-search.payload';
import { VehicleSearchResponse } from '@autos/entities/vehicle-search.response';
import { FilterSorterCriterias } from '@autos/auto-results/entities/filters';

export const searchAutoAction = createAction(type('[Autos/API] Search autos'),
  props<{ payload: VehicleSearchPayload, filters: VehicleResultsPayload }>());
export const searchAutoSuccessAction = createAction(type('[Autos/API] Search autos success'),
  props<{ response: VehicleSearchResponse, session: string }>());

export const searchAutoMarkersAction = createAction(type('[Autos/API] Search autos markers'),
  props<{ payload: AutoFiltersPayloadState }>());
export const searchAutoMarkersSuccessAction = createAction(type('[Autos/API] Search autos markers success'),
  props<{ response: VehicleSearchResponse, session: string }>());

export const fetchAutoFiltersAction = createAction(type('[Autos/API] Fetch auto filters'),
  props<{ payload: VehicleFilterPayload }>());
export const fetchAutoFiltersSuccessAction = createAction(type('[Autos/API] Fetch auto filters success'),
  props<{ filters: VehicleFilterResponse }>());

export const fetchAutoResultsAction = createAction(type('[Autos/API] Fetch autos with filters'),
  props<{ payload: VehicleResultsPayload }>());
export const fetchAutoResultsSuccessAction = createAction(type('[Autos/API] Fetch autos with filters success'),
  props<{ autos: VehicleOption[] }>());
export const clearAutoResultsAction = createAction(type('[Autos/DATA] Clear auto results'));
export const clearAutoCategoriesAction = createAction(type('[Autos/DATA] Clear auto categories'));

export const saveAutoFiltersAction = createAction(type('[Autos/API] Save autos filters'),
  props<{ payload: VehicleResultsPayload }>());
export const resetAutoFiltersAction = createAction(type('[Autos/API] Reset autos filters'));
export const resetAutoFiltersPayloadAction = createAction(type('[Autos/API] Reset autos filters payload'));

export const fetchAutoMarkersWithFiltersAction = createAction(type('[Autos/API] Fetch autos markers with filters'),
  props<{ payload: VehicleResultsPayload }>());
export const fetchAutoMarkersWithFiltersSuccessAction =
  createAction(type('[Autos/API] Fetch autos markers with filters success'), props<{ autos: VehicleOption[] }>());

export const fetchAutoCategoriesResultsAction = createAction(type('[Autos/API] Fetch autos results categories'),
  props<{ payload: VehicleResultsPayload }>());
export const fetchAutoCategoriesResultsSuccessAction = createAction(type('[Autos/API] Fetch autos results categories success'),
  props<{ categories: AutoCategorySlide[] }>());

export const fetchAutoWithPaginationAction = createAction(type('[Autos/API] Fetch autos with pagination'),
  props<{ payload: VehicleResultsPayload }>());
export const fetchAutoWithPaginationSuccessAction = createAction(type('[Autos/API] Fetch autos with pagination success'),
  props<{ autos: VehicleOption[] }>());

export const setFilterSorterAction = createAction(type('[Autos/DATA] Set Filter Sorter'),
  props<{ payload: FilterSorterCriterias }>());

export const searchAutoErrorAction = createAction(type('[Autos/DATA] Auto Results error'),
  props<{ payload: HttpErrorResponse }>());

export const searchAutoCategoriesErrorAction = createAction(type('[Autos/DATA] Auto Categories error'),
  props<{ payload: HttpErrorResponse }>());

